module.exports = __webpack_public_path__ + "img/select-arrows.e6b209b1.svg";